import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { StepHeader, DataImportBox, SpreadsheetEditor, DeliveryList } from './index';
import {
    LogisticsStep,
    SpreadsheetData,
    SpreadsheetColumn,
    DeliveryListPrintData,
    DeliveryListFormData,
    VehicleDropdownOption,
    MontageTeamDropdownOption,
} from '@/modules/Logistics/interfaces/LogisticsInterfaces';

interface DropdownSelectPayload {
    value: string;
    row: number;
    col: number;
    columnKey: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryTransformator',
  props: {
    currentStep: null,
    rawData: null,
    spreadsheetData: null,
    columns: null,
    printData: null,
    isParsing: { type: Boolean },
    isEditMode: { type: Boolean },
    steps: null,
    montageTeams: null,
    vehicles: null,
    totalPieces: null
  },
  emits: ["update:rawData", "update:spreadsheetData", "update:printData", "data-pasted", "data-change", "dropdown-select", "form-field-update", "print-spreadsheet-change", "step-change", "print", "open-project"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:rawData', value: string): void;
    (e: 'update:spreadsheetData', value: SpreadsheetData | null): void;
    (e: 'update:printData', value: DeliveryListPrintData): void;
    (e: 'data-pasted', data: string): void;
    (e: 'data-change', data: SpreadsheetData | null): void;
    (e: 'dropdown-select', payload: DropdownSelectPayload): void;
    (
        e: 'form-field-update',
        field: keyof DeliveryListFormData,
        value: DeliveryListFormData[keyof DeliveryListFormData],
    ): void;
    (e: 'print-spreadsheet-change', data: SpreadsheetData | null): void;
    (e: 'step-change', step: number): void;
    (e: 'print'): void;
    (e: 'open-project', payload: DropdownSelectPayload): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    currentStep: number;
    rawData: string;
    spreadsheetData: SpreadsheetData | null;
    columns: SpreadsheetColumn[];
    printData: DeliveryListPrintData;
    isParsing: boolean;
    isEditMode: boolean;
    steps: LogisticsStep[];
    montageTeams: MontageTeamDropdownOption[];
    vehicles: VehicleDropdownOption[];
    totalPieces: number;
};





const spreadsheetEditorRef = ref<InstanceType<typeof SpreadsheetEditor> | null>(null);
const deliveryListRef = ref<InstanceType<typeof DeliveryList> | null>(null);

// Computed properties
const currentStepSubtitle = computed(() => {
    if (props.currentStep === 0) {
        if (props.spreadsheetData?.rows && Object.keys(props.spreadsheetData.rows).length > 1) {
            return `${Object.keys(props.spreadsheetData.rows).length - 1} rows ready`;
        }
        return 'Step 1 of 3';
    }
    if (props.spreadsheetData?.rows) {
        return `${Object.keys(props.spreadsheetData.rows).length - 1} rows`;
    }
    return '';
});

// Event handlers - emit to parent
function handleDataPasted(data: string) {
    emit('data-pasted', data);
}

function handleRawDataInput(value: string) {
    emit('update:rawData', value);
}

function handleDataChange(data: SpreadsheetData | null) {
    emit('data-change', data);
    emit('update:spreadsheetData', data);
}

function handleFormFieldUpdate(
    field: keyof DeliveryListFormData,
    value: DeliveryListFormData[keyof DeliveryListFormData],
) {
    emit('form-field-update', field, value);
}

function handlePrintSpreadsheetChange(data: SpreadsheetData | null) {
    emit('print-spreadsheet-change', data);
}

function handleDropdownSelect(payload: DropdownSelectPayload) {
    emit('dropdown-select', payload);
}

function handleOpenProject(payload: DropdownSelectPayload) {
    emit('open-project', payload);
}

function print() {
    deliveryListRef.value?.print();
}

function reloadSpreadsheetData(data: SpreadsheetData) {
    spreadsheetEditorRef.value?.reloadData(data);
}

// Expose methods for parent
expose({
    print,
    reloadSpreadsheetData,
    currentStepSubtitle,
});

return { __sfc: true,props, emit, spreadsheetEditorRef, deliveryListRef, currentStepSubtitle, handleDataPasted, handleRawDataInput, handleDataChange, handleFormFieldUpdate, handlePrintSpreadsheetChange, handleDropdownSelect, handleOpenProject, print, reloadSpreadsheetData, StepHeader, DataImportBox, SpreadsheetEditor, DeliveryList }
}

})